import { useTranslation } from "react-i18next";
import { Box, Flex } from "@mantine/core"
import { Button, Link, Modal, Text } from "components"
import { useState } from "react";
import { StatusActions } from "types";

const ProcessingStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  return (
    <>
      <Box ml={'sm'}>
        <Button size={'compact-md'} onClick={() => onClick('APPROVED')} loading={isLoading}>
          {t('credit.status.action.APPROVED')}
        </Button>
      </Box>
      <Box ml={'sm'}>
        <Button size={'compact-md'} variant={'outline'} color={'var(--mantine-color-error)'} onClick={() => setModalVisible(true)} loading={isLoading}>
          {t('credit.status.action.REJECTED')}
        </Button>
      </Box>
      <Modal opened={modalVisible} onClose={() => setModalVisible(false)} withCloseButton={false}>
        <Text ta={'center'} mt={24} mb={12} style={{ fontWeight: 'bold' }}>{t('credit.status.confirmation.REJECTED.title')}</Text>
        <Text ta={'center'} mb={24}>{t('credit.status.confirmation.REJECTED.description')}</Text>
        <Flex mt={32} mb={12} justify={'space-between'} align={'center'} px={32}>
          <Link onClick={() => setModalVisible(false)} disabled={isLoading} c={'var(--mantine-color-gray-7)'}>
            {t('credit.status.confirmation.REJECTED.cancel')}
          </Link>
          <Button onClick={() => onClick('REJECTED')} disabled={isLoading} color={'var(--mantine-color-error)'}>
            <Text>{t('credit.status.confirmation.REJECTED.submit')}</Text>
          </Button>
        </Flex>
    </Modal>
    </>
  )
}

export default ProcessingStatusActions;